import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiBriefcase, FiUsers, FiPackage, FiTrendingUp, FiDollarSign, FiActivity } from 'react-icons/fi';
import { formatINR } from '../../utils/currency';

const CompanyOverview = () => {
  const [stats, setStats] = useState({
    totalEmployees: 0,
    totalProducts: 0,
    totalOrders: 0,
    monthlyRevenue: 0,
    activeDistributors: 0,
    pendingOrders: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      // TODO: Replace with actual API endpoint
      // const response = await axios.get(`${API_ENDPOINTS.base}/company/overview`);
      // setStats(response.data);
      
      // Mock data
      setStats({
        totalEmployees: 125,
        totalProducts: 450,
        totalOrders: 1234,
        monthlyRevenue: 1250000,
        activeDistributors: 45,
        pendingOrders: 23
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    { icon: FiUsers, label: 'Total Employees', value: stats.totalEmployees, color: 'blue' },
    { icon: FiPackage, label: 'Total Products', value: stats.totalProducts, color: 'green' },
    { icon: FiActivity, label: 'Total Orders', value: stats.totalOrders, color: 'purple' },
    { icon: FiDollarSign, label: 'Monthly Revenue', value: formatINR(stats.monthlyRevenue), color: 'yellow' },
    { icon: FiBriefcase, label: 'Active Distributors', value: stats.activeDistributors, color: 'indigo' },
    { icon: FiTrendingUp, label: 'Pending Orders', value: stats.pendingOrders, color: 'red' }
  ];

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600',
    purple: 'bg-purple-100 text-purple-600',
    yellow: 'bg-yellow-100 text-yellow-600',
    indigo: 'bg-indigo-100 text-indigo-600',
    red: 'bg-red-100 text-red-600'
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
          <FiBriefcase className="text-blue-600" />
          Company Overview
        </h1>
        <p className="text-gray-600 mt-1">Zovcur Pharmaceutical Company - Key Metrics & Statistics</p>
      </div>

      {loading ? (
        <div className="text-center py-12">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
            {statCards.map((stat, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-gray-600 text-sm font-medium">{stat.label}</p>
                    <p className="text-2xl font-bold text-gray-800 mt-2">{stat.value}</p>
                  </div>
                  <div className={`p-3 rounded-full ${colorClasses[stat.color]}`}>
                    <stat.icon className="w-6 h-6" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg shadow-md p-6">
              <h2 className="text-xl font-bold text-gray-800 mb-4">Recent Activities</h2>
              <div className="space-y-3">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div key={i} className="flex items-center gap-3 pb-3 border-b last:border-0">
                    <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                    <div className="flex-1">
                      <p className="text-sm text-gray-800">New order received from distributor</p>
                      <p className="text-xs text-gray-500">2 hours ago</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <h2 className="text-xl font-bold text-gray-800 mb-4">Quick Actions</h2>
              <div className="space-y-2">
                <button className="w-full text-left px-4 py-3 bg-blue-50 hover:bg-blue-100 rounded-lg text-blue-700 font-medium">
                  Create New Order
                </button>
                <button className="w-full text-left px-4 py-3 bg-green-50 hover:bg-green-100 rounded-lg text-green-700 font-medium">
                  Add New Product
                </button>
                <button className="w-full text-left px-4 py-3 bg-purple-50 hover:bg-purple-100 rounded-lg text-purple-700 font-medium">
                  View Reports
                </button>
                <button className="w-full text-left px-4 py-3 bg-yellow-50 hover:bg-yellow-100 rounded-lg text-yellow-700 font-medium">
                  Manage Inventory
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CompanyOverview;

